import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface ImportFailedBannerProps {
  errorMessage?: string;
}

const ImportFailedBanner: React.FC<ImportFailedBannerProps> = ({
  errorMessage,
}) => {
  return (
    <div className='px-4 py-3 bg-orange-50 border-t border-orange-200'>
      <div className='flex items-start gap-2'>
        <InformationCircleIcon className='w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5' />
        <div className='flex-1'>
          <p className='text-sm font-medium text-orange-900'>Import Failed</p>
          <p className='text-xs text-orange-700 mt-1'>
            This booking could not be imported. Please check the booking data
            and try again.
          </p>
          {errorMessage && (
            <p className='text-xs text-orange-600 mt-2 font-mono bg-orange-100 p-2 rounded border border-orange-200 break-all whitespace-pre-wrap'>
              {errorMessage}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImportFailedBanner;
